import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';

export default function BatteryTechnology() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.BatteryTechnology');
    return (
        <div className={`${styles.batteryTechnology}`}>
            <div className="bg-img">
                <EcoImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713519117066/Battery%20Technology-tuya.jpg" alt={t('title')} />
            </div>
            <div className="text-box">
                <div className="sub-title">{t('label')}</div>
                <h2 className="title">{t('title')}</h2>
                <div className="text-desc">{t('desc')}</div>
                <div className="worp">
                    <h3 className="worp-item">
                        <span className="item-title first-item-title">{t('item_title1')}</span>
                        <span className="item-desc">{t('item_desc1')}</span>
                    </h3>
                    <h3 className="worp-item">
                        <span className="item-title">{t('item_title2')}</span>
                        <span className="item-desc">{t('item_desc2')}</span>
                    </h3>
                    <h3 className="worp-item">
                        <span className="item-title">{t('item_title3')}</span>
                        <span className="item-desc">{t('item_desc3')}</span>
                    </h3>
                    <h3 className="worp-item">
                        <span className="item-title">{t('item_title4')}</span>
                        <span className="item-desc">{t('item_desc4')}</span>
                    </h3>
                </div>
            </div>
        </div>
    );
}
export const getStaticProps = async () => {
    return {
        props: {},
    };
};
